import { Drawer, Empty, Space, Timeline } from "antd";
import { Typography } from "antd";
import { useBuscarAndamentosCompatibilidade } from "../hooks/useBuscarAndamentosCompatibilidade";
import { useEffect } from "react";
import dayjs from "dayjs";

const { Text } = Typography;

interface ModalAndamentosCompatibilidadeProps {
  isModalOpen: boolean;
  handleFechar: () => void;
  compatibilidadeId: number | null;
}

export default function ModalAndamentosCompatibilidade({
  isModalOpen,
  handleFechar,
  compatibilidadeId,
}: ModalAndamentosCompatibilidadeProps) {
  const { andamentos, loading, buscar } = useBuscarAndamentosCompatibilidade();

  useEffect(() => {
    if (isModalOpen && compatibilidadeId) {
      buscar(compatibilidadeId);
    }
  }, [isModalOpen, compatibilidadeId, buscar]);

  const getTipoIcon = (tipo: string) => {
    switch (tipo) {
      case "MUDANCA":
        return "🔄";
      case "CRIACAO":
        return "✨";
      case "EXCLUSAO":
        return "🗑️";
      case "ATUALIZACAO":
        return "📝";
      default:
        return "📋";
    }
  };

  return (
    <Drawer
      onClose={handleFechar}
      open={isModalOpen}
      title="Andamentos da Compatibilidade"
      width={600}
      destroyOnClose
    >
      {loading ? (
        <div style={{ textAlign: "center", padding: "40px 20px" }}>
          <Space direction="vertical" style={{ width: "100%", alignItems: "center" }}>
            <div style={{ fontSize: "24px" }}>⏳</div>
            <Text type="secondary">Carregando andamentos...</Text>
          </Space>
        </div>
      ) : andamentos.length === 0 ? (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={
            <div>
              <p style={{ marginBottom: "8px", fontWeight: "500" }}>
                Nenhum andamento registrado
              </p>
              <p style={{ fontSize: "12px", color: "#999" }}>
                Os andamentos aparecerão aqui conforme a compatibilidade for processada.
              </p>
            </div>
          }
          style={{ marginTop: "40px" }}
        />
      ) : (
        <Timeline
          mode="left"
          items={andamentos.map((andamento: any, index: number) => {
            return {
              children: (
                <div style={{ marginBottom: "12px" }}>
                  <div style={{ display: "flex", alignItems: "center", marginBottom: "4px" }}>
                    <span style={{ marginRight: "8px", fontSize: "16px" }}>
                      {getTipoIcon(andamento.tipo)}
                    </span>
                    <Text strong style={{ flex: 1 }}>
                      {andamento.descricao}
                    </Text>
                  </div>
                  <div style={{ marginLeft: "24px" }}>
                    <Text type="secondary" style={{ fontSize: "12px", display: "block", marginBottom: "4px" }}>
                      {dayjs(andamento.criadoPor.em).format("DD/MM/YYYY HH:mm")}
                    </Text>
                    {andamento.observacoes ? (
                      <Text style={{ display: "block", marginBottom: "8px" }}>
                        {andamento.observacoes}
                      </Text>
                    ) : null}
                    {(() => {
                      // Lógica para extrair o nome do autor
                      let autor = "";
                      let icon = "👤";

                      if (andamento.criadoPor) {
                        // Novo formato: criadoPor
                        if (andamento.criadoPor.tipo === "SISTEMA") {
                          autor = "Sistema";
                          icon = "⚙️";
                        } else if (andamento.criadoPor.tipo === "USUARIO" && andamento.criadoPor.nome) {
                          autor = andamento.criadoPor.nome;
                        } else {
                          autor = andamento.criadoPor.tipo || "";
                        }
                      }

                      if (!autor) return null;

                      return (
                        <Text style={{ fontSize: "12px", color: "#1890ff", fontWeight: "500" }}>
                          {icon} Por: {autor}
                        </Text>
                      );
                    })()}
                  </div>
                </div>
              ),
              color:
                andamento.tipo === "MUDANCA"
                  ? "orange"
                  : andamento.tipo === "CRIACAO"
                  ? "green"
                  : andamento.tipo === "EXCLUSAO"
                  ? "red"
                  : "gray",
            };
          })}
        />
      )}
    </Drawer>
  );
}
